"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const enums_1 = require("../enums");
exports.getCookie = (name) => js_cookie_1.default.get(name);
exports.expireCookie = (name, options) => js_cookie_1.default.remove(name, options);
exports.setCookie = (name, value, options) => js_cookie_1.default.set(name, value, options);
exports.expireOption = {
    expires: 1 / 24,
};
exports.resetCookies = () => {
    // user cookies
    exports.expireCookie(enums_1.CookiesType.token, exports.expireOption);
    exports.expireCookie(enums_1.CookiesType.refreshToken);
    exports.expireCookie(enums_1.CookiesType.role, exports.expireOption);
    // admin cookies
    exports.expireCookie(enums_1.CookiesType.adminToken, exports.expireOption);
    exports.expireCookie(enums_1.CookiesType.adminRefreshToken);
};
//# sourceMappingURL=manage-token.js.map